(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bf-product-tabs"] && !Shopify.designMode) return;
  try {
    function initializeBfProductTabs(root) {
    const tabGroups = root.querySelectorAll('[data-bf-product-tabs]');

    tabGroups.forEach((tabGroup) => {
      tabGroup.querySelectorAll('.tab__header').forEach((header) => {
        if (header.dataset.bfProductTabBound === 'true') return;

        header.dataset.bfProductTabBound = 'true';
        header.addEventListener('click', () => {
          const isActive = header.classList.toggle('active');
          header.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      });
    });
  }

  initializeBfProductTabs(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializeBfProductTabs(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
